import { createAction } from '@reduxjs/toolkit';

const gotoClientPortal = createAction('route/gotoClientPortal');
const gotoVerifyApp = createAction('route/gotoVerifyApp');
const gotoCreditApp = createAction('route/gotoCreditApp');

export { gotoClientPortal, gotoVerifyApp, gotoCreditApp };
